import React, {Fragment} from 'react';
import {translate} from "react-i18next";
import connect from "react-redux/es/connect/connect";
import {load} from "../../actions/logbookAction";
import moment from "moment";
import LogbookApi from "../../apis/LogbookApi";
import Comments from "./Comments";
import Popover from "react-awesome-popover";
import Select2 from "react-select2-wrapper";
import reactStringReplace from "react-string-replace";

class Task extends React.Component {

    state = {
        editing: false,
        loaded: false,
        startDelete: false,
        deleted: false,
        editLoading: false,
        editMessage: '',
        editErrors: {},
        editStatus: false,
        editAssignee: false
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.entry && nextProps.entry.version !== prevState.version) {
            let newState = {
                ...nextProps.entry,
                loaded: true
            };
            if (nextProps.entry.message !== prevState.editMessage && !prevState.editing) {
                newState.editMessage = nextProps.entry.message;
            }
            return newState;
        }
        return null;
    }

    deleteEntry = () => {
        this.setState({deleted: true});
        LogbookApi.deleteEntry(this.state.id);
    };

    editEntry = (e) => {
        e.preventDefault();
        this.setState({editLoading: true, editErrors: {}});
        LogbookApi.editEntry(this.state.id, {
            type: 'TASK',
            message: this.state.editMessage
        }).then((result) => {
            if (result.data.success === true) {
                this.setState({
                    message: this.state.editMessage,
                    editLoading: false,
                    editing: false
                });
            } else {
                this.setState({
                    editErrors: result.data.errors,
                    editLoading: false
                });
            }
        });
    };

    changeStatus = (e) => {
        LogbookApi.changeStatus(this.state.id, {status: e.target.value});
        this.setState({
            status: e.target.value,
            editStatus: false
        });
    };

    changeAssignee = (e) => {
        LogbookApi.changeAssignee(this.state.id, {assignee: e.target.value});
        this.setState({
            assignee: this.props.logbook.availableAssignees.find((el) => el.id === parseInt(e.target.value)),
            editAssignee: false
        });
    };

    removeAssignee = () => {
        LogbookApi.changeAssignee(this.state.id, {assignee: null});
        this.setState({
            assignee: null,
            editAssignee: false
        });
    };

    render() {
        const {authorization, t} = this.props;
        return !this.state.deleted ? (
            <div className="entry" style={{whiteSpace: 'pre-wrap'}}>
                {this.state.loaded ? (
                    this.state.editing ? (
                        <Fragment>
                            <form onSubmit={this.editEntry}>
                                <div
                                    className={"form-group" + ((this.state.editErrors && this.state.editErrors.message) ? ' has-error' : '')}>
                                    <label>
                                        {t('logbook.entry.message')}
                                    </label>
                                    <textarea className="form-control" value={this.state.editMessage}
                                              onChange={(e) => this.setState({editMessage: e.target.value})}
                                              disabled={this.state.loading}/>
                                    {(this.state.editErrors && this.state.editErrors.message) ? (
                                        <span className="help-block">
                                                {t('logbook.message.error.' + this.state.editErrors.message)}
                            </span>
                                    ) : null}
                                </div>
                                <div className="button-container text-right">
                                    <div className="btn-group">
                                        <button type="cancel" className="btn btn-sm btn-default"
                                                disabled={this.state.editLoading} onClick={() => this.setState({
                                            editErrors: {},
                                            editMessage: this.state.message,
                                            editing: false
                                        })}>
                                            <i className="fa fa-close m-r-xs"/>{t('default.cancel')}
                                        </button>
                                        <button type="submit" className="btn btn-sm btn-primary"
                                                disabled={this.state.editLoading}>
                                            <i className={`fa fa-${this.state.editLoading ? 'spin fa-spinner' : 'save'} m-r-xs`}/> {t('default.save')}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <div className="row m-t-n m-b-n">
                                <div className="col-xs-4">
                                    {t('logbook.entry.status.title')}:&nbsp;
                                    <Popover targetClass="" onOpen={() => this.setState({editStatus: true})}
                                             onClose={() => this.setState({editStatus: false})}
                                             open={this.state.editStatus} contentClass="rap-popover-content">
                                        <button ref="target"
                                                className={`btn btn-xs btn-${this.state.status ? this.state.status === 'DONE' ? 'primary' : this.state.status === 'IN_PROGRESS' ? 'warning' : 'default' : 'default'}`}>
                                            {t(`logbook.entry.status.${this.state.status ? this.state.status : 'NONE'}`)}
                                            <i className="fa fa-edit m-l-xs"/>
                                        </button>
                                        <div className="p-md">
                                            <div
                                                className="form-group" style={{width: '200px'}}>
                                                <label>
                                                    {t('logbook.entry.status.title')}
                                                </label>
                                                <Select2 data={[
                                                    {id: 'CREATED', text: t('default.task.status.created')},
                                                    {id: 'IN_PROGRESS', text: t('default.task.status.inProgress')},
                                                    {id: 'DONE', text: t('default.task.status.done')},
                                                ]} value={this.state.status} onChange={this.changeStatus} name="status"
                                                         options={{placeholder: t('logbook.status.placeholder')}}
                                                         className="width-100p block"/>
                                            </div>
                                        </div>
                                    </Popover>
                                </div>
                                <div className="col-xs-4">
                                    {t('logbook.entry.assignee.title')}:&nbsp;
                                    <Popover targetClass="" onOpen={() => this.setState({editAssignee: true})}
                                             onClose={() => this.setState({editAssignee: false})}
                                             open={this.state.editAssignee} contentClass="rap-popover-content">
                                        <button ref="target"
                                                className={`btn btn-xs btn-${this.state.assignee ? 'success' : 'default'}`}>
                                            {this.state.assignee ? this.state.assignee.username : t('logbook.entry.assignee.none')}
                                            <i className="fa fa-edit m-l-xs"/>
                                        </button>
                                        <div className="p-md">
                                            <div className="form-group" style={{width: '200px'}}>
                                                <label>
                                                    {t('logbook.entry.assignee.title')}
                                                </label>
                                                <Select2 data={this.props.logbook.availableAssignees.map((el) => {
                                                    return {
                                                        text: el.username, id: el.id
                                                    }
                                                })} value={this.state.assignee ? this.state.assignee.id : null} onChange={this.changeAssignee} name="assignee"
                                                         disabled={this.state.loading}
                                                         options={{placeholder: t('logbook.assignee.placeholder')}}
                                                         className="width-100p block"/>
                                                {(this.state.errors && this.state.errors.assignee) ? (
                                                    <span className="help-block">
                                                {t('logbook.assignee.error.' + this.state.errors.assignee)}
                            </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </Popover>
                                    {this.state.assignee ? (
                                        <button className="btn btn-xs btn-success" onClick={this.removeAssignee}>
                                            <i className="fa fa-trash"/>
                                        </button>
                                    ) : null}
                                </div>
                                <div className="menu-container col-xs-4 text-right">
                                    <small className="text-muted block">
                                        {this.state.createdBy.username}, {moment(this.state.createdAt).format('DD.MM.YYYY HH:mm')}
                                    </small>
                                    {this.state.createdBy.username === authorization.username ? (
                                        <Fragment>
                                            <button className="btn btn-xs no-borders btn-outline btn-primary"
                                                    type="default"
                                                    onClick={() => this.setState({editing: true})}>
                                                <i className="fa fa-pencil"/>
                                            </button>
                                            <button className="btn btn-xs no-borders btn-outline btn-danger"
                                                    type="default"
                                                    onClick={() => this.setState({startDelete: true})}>
                                                <i className="fa fa-trash"/>
                                            </button>
                                        </Fragment>
                                    ) : null}
                                </div>
                            </div>
                            {reactStringReplace(this.state.message, /#(\w+)/g, (match, i) => (
                                <span className="hashtag" key={match + i} onClick={() => this.props.setSearchInformation(`#${match}`)}>#{match}</span>
                            ))}
                            {this.state.startDelete ? (
                                <div className="m-t-md">
                                    <div className="text-danger">
                                        {t('logbook.information.reallyDelete')}
                                    </div>
                                    <div className="btn-group m-t-xs">
                                        <button type="cancel" className="btn btn-default btn-xs"
                                                onClick={() => this.setState({startDelete: false})}>
                                            <i className="fa fa-close m-r-xs"/>
                                            {t('default.cancel')}
                                        </button>
                                        <button type="default" className="btn btn-danger btn-xs"
                                                onClick={this.deleteEntry}>
                                            <i className="fa fa-trash m-r-xs"/>
                                            {t('default.delete')}
                                        </button>
                                    </div>
                                </div>
                            ) : null}
                        </Fragment>
                    )
                ) : null}
                <Comments comments={this.state.comments} entryId={this.state.id} key={`c-${this.state.id}`} setSearchInformation={this.props.setSearchInformation}/>
                <div className="clear"/>
            </div>
        ) : null
    }
}

const mapStateToProps = state => ({
    logbook: state.logbook,
    authorization: state.authorization
});

export default connect(mapStateToProps, {
    load
})(translate()(Task));
